"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IllustrationHousesBackgroundWithComposition = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      viewBox: "0 0 1462 159",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-1",
          x: "24",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-2",
          x: "24",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-3",
          x: "32",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-4",
          x: "32",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-5",
          x: "44",
          y: "36",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-6",
          x: "44",
          y: "44",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-7",
          x: "44",
          y: "52",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-8",
          x: "44",
          y: "60",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-9",
          x: "44",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-10",
          x: "44",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-11",
          x: "52",
          y: "4",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-12",
          x: "52",
          y: "12",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-13",
          x: "52",
          y: "20",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-14",
          x: "52",
          y: "28",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-15",
          x: "52",
          y: "36",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-16",
          x: "52",
          y: "44",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-17",
          x: "52",
          y: "52",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-18",
          x: "52",
          y: "60",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-19",
          x: "52",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-20",
          x: "52",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-21",
          x: "24",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-22",
          x: "24",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-23",
          x: "32",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-24",
          x: "32",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-25",
          x: "44",
          y: "36",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-26",
          x: "44",
          y: "44",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-27",
          x: "44",
          y: "52",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-28",
          x: "44",
          y: "60",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-29",
          x: "44",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-30",
          x: "44",
          y: "76",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-31",
          x: "52",
          y: "4",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-32",
          x: "52",
          y: "12",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-33",
          x: "52",
          y: "20",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-34",
          x: "52",
          y: "28",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-35",
          x: "52",
          y: "36",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-36",
          x: "52",
          y: "44",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-37",
          x: "52",
          y: "52",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-38",
          x: "52",
          y: "60",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-39",
          x: "52",
          y: "68",
          width: "4",
          height: "4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          id: "path-40",
          x: "52",
          y: "76",
          width: "4",
          height: "4"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(11.000000, -61.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(-11.000000, 61.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M11,67 C34.7750236,67 38.8626593,83 54.712675,83 C70.5626908,83 54.217362,83 77.9923856,83 C101.767409,83 84.9267675,67 110.18773,67 C135.448693,67 118.608051,51 141.887762,51 C165.167472,51 160.173826,51 173.09248,51 C186.011134,51 181.017488,67 204.792512,67 C228.567535,67 228.567535,67 252.342559,67 C276.117583,67 268.192575,83 291.967598,83 C315.742622,83 299.892606,83 323.66763,83 C347.442653,83 331.592638,99 359.330165,99 C387.067693,99 371.217677,99 398.955205,99 C426.692732,99 410.842716,83 434.61774,83 C458.392764,83 442.542748,67 474.242779,67 C505.942811,67 482.167787,67 505.942811,67 C529.717835,67 521.792827,83 545.56785,83 C569.342874,83 545.56785,83 561.417866,83 C577.267882,83 569.342874,99 593.117898,99 C616.892921,99 593.117898,99 608.967913,99 C624.817929,99 616.892921,83 640.667945,83 C664.442968,83 632.742937,83 656.517961,83 C680.292984,83 664.442968,99 688.217992,99 C711.993016,99 696.143,115 719.918024,115 C743.693047,115 717.936772,115 735.768039,115 C753.599307,115 743.197734,115 767.468071,115 C791.738407,115 783.318087,99 807.588423,99 C831.85876,99 815.513431,99 839.288455,99 C863.063478,99 854.147844,83 886.343189,83 C918.538533,83 907.146335,83 942.313557,83 C977.480779,83 965.593268,99 989.368291,99 C1013.14331,99 1060.69336,99 1084.46839,99 C1108.24341,99 1092.39339,83 1124.09343,83 C1145.22678,83 1166.36013,83 1187.49349,83 C1196.73933,83 1209.28726,83 1225.13728,83 C1248.9123,83 1255.86036,99 1274.66857,99 C1293.47679,99 1289.58034,99 1322.21862,99 C1354.8569,99 1338.06864,115 1361.84366,115 C1385.61869,115 1377.69368,115 1401.4687,115 C1425.24372,115 1420.27121,99 1433.16873,99 C1441.76708,99 1447.71083,99 1451,99 L1451,157 L11,157 C11,97 11,67 11,67 Z",
              fill: "#E1EBF9",
              className: "fill-primary5"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(92.500000, 95.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "60"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "20",
                    height: "60"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L48,0 L48,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "54",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "54",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "54",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(127.500000, 85.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M36,12 L36,0 L64,0 L64,12 L52,12 L52,24 L40,24 L40,36 L28,36 L28,72 L0,72 L0,36 L12,36 L12,24 L24,24 L24,12 L36,12 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M64,12 L64,0 L76,0 L76,72 L28,72 L28,36 L40,36 L40,24 L52,24 L52,12 L64,12 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "4",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "52",
                    y: "4",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M70,4 C71.1045695,4 72,4.8954305 72,6 L72,12 L72,12 L68,12 L68,6 C68,4.8954305 68.8954305,4 70,4 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "68",
                    y: "16",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "64",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "8",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(192.500000, 69.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 20 40 20 20 32 0 32"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M20,88 L20,32 L40,20 L40,0 L60,0 L60,88 L20,88 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "36",
                    width: "4",
                    height: "48"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "36",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "44",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "52",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "60",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-1"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-1"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-2"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-2"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "36",
                    width: "4",
                    height: "48"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "36",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "44",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "52",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "60",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-3"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-3"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-4"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-4"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "20",
                    y: "0",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-5"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-5"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-6"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-6"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-7"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-7"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-8"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-8"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-9"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-9"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-10"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-10"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "4",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-11"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-11"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-12"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-12"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-13"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-13"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-14"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-14"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-15"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-15"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-16"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-16"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-17"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-17"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-18"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-18"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-19"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-19"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-20"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-20"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(322.000000, 0.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "4",
                    width: "40",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    transform: "translate(20.000000, 2.000000) scale(1, -1) translate(-20.000000, -2.000000) ",
                    x: "8",
                    y: "0",
                    width: "24",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,4 L32,0 L48,0 L48,4 L56,4 L56,128 L40,128 L40,4 L32,4 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "28",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "12",
                    width: "8",
                    height: "108"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(244.000000, 23.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "48",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "0",
                    width: "20",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "38",
                    height: "100"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "4 44 4 32 42 56 42 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "4 53 4 48 42 72 42 77"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "52",
                    y: "16",
                    width: "12",
                    height: "100"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "6",
                    width: "16",
                    height: "6"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(342.500000, 69.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "8",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "16",
                    width: "4",
                    height: "32"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(382.500000, 83.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "8",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "16",
                    width: "4",
                    height: "32"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(269.000000, 77.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "16",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "40",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "48",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "0",
                    width: "16",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "8",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "16",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "24",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "32",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "40",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "48",
                    width: "16",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(444.000000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "16",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "40",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "48",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "0",
                    width: "16",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "8",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "16",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "24",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "32",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "40",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "48",
                    width: "16",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(224.500000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(513.000000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(280.500000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(348.500000, 129.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "20",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "4",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(398.500000, 65.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "20",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 0 40 0 20 20 0 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 20 40 0 40 20 40 76 20 76"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "64",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(485.500000, 81.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "20",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 0 40 0 20 20 0 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 20 40 0 40 20 40 76 20 76"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "64",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(56.000000, 121.000000) scale(-1, 1) translate(-56.000000, -121.000000) translate(14.000000, 97.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "36",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "24",
                    width: "12",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "72",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "30 0 32 0 32 24 28 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "16 0 18 0 18 24 14 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "32 0 34 0 36 24 32 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "18 0 20 0 22 24 18 24"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(612.500000, 91.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "32",
                    y: "12",
                    width: "12",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M20,52 L20,32 L44,32 L44,12 L56,12 L56,52 L20,52 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "44 0 44 12 32 12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    cx: "38",
                    cy: "18",
                    r: "2"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    cx: "50",
                    cy: "18",
                    r: "2"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "44 0 56 12 44 12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 32 10 24 20 32 20 52 0 52"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "10 24 38 24 48 32 20 32"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M10,40 C11.1045695,40 12,40.8954305 12,42 L12,52 L12,52 L8,52 L8,42 C8,40.8954305 8.8954305,40 10,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M26,36 C27.1045695,36 28,36.8954305 28,38 L28,48 L28,48 L24,48 L24,38 C24,36.8954305 24.8954305,36 26,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M34,36 C35.1045695,36 36,36.8954305 36,38 L36,48 L36,48 L32,48 L32,38 C32,36.8954305 32.8954305,36 34,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,36 C43.1045695,36 44,36.8954305 44,38 L44,48 L44,48 L40,48 L40,38 C40,36.8954305 40.8954305,36 42,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "8",
                    y: "32",
                    width: "4",
                    height: "4",
                    rx: "2"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(388.000000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(172.000000, 121.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(29.500000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(576.500000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(422.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(150.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(186.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(461.500000, 119.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M16,14 L16,2 L52,2 L52,14 L44,14 L44,26 L36,26 L36,38 L0,38 L0,26 L8,26 L8,14 L16,14 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "30",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "30",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "30",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M44,26 L44,14 L52,14 L52,2 L64,2 L64,38 L36,38 L36,26 L44,26 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "36",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "36",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "44",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M16,2 L16,0 L64,0 L64,2 L16,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(675.000000, 133.000000) scale(-1, 1) translate(-675.000000, -133.000000) translate(633.000000, 109.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "36",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "24",
                    width: "12",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "72",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "30 0 32 0 32 24 28 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "16 0 18 0 18 24 14 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "32 0 34 0 36 24 32 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "18 0 20 0 22 24 18 24"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(604.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(0.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(699.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(533.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "44",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 50 0 44 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "44 8 50 0 56 8 56 20 44 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(61.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "44",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 50 0 44 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "44 8 50 0 56 8 56 20 44 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(731.000000, 0.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(92.500000, 95.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "60"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "20",
                    height: "60"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L48,0 L48,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "54",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "54",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "54",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "46",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "38",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(127.500000, 85.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M36,12 L36,0 L64,0 L64,12 L52,12 L52,24 L40,24 L40,36 L28,36 L28,72 L0,72 L0,36 L12,36 L12,24 L24,24 L24,12 L36,12 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M64,12 L64,0 L76,0 L76,72 L28,72 L28,36 L40,36 L40,24 L52,24 L52,12 L64,12 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "4",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "52",
                    y: "4",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "28",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "16",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M70,4 C71.1045695,4 72,4.8954305 72,6 L72,12 L72,12 L68,12 L68,6 C68,4.8954305 68.8954305,4 70,4 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "68",
                    y: "16",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "64",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "8",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(192.500000, 69.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 20 40 20 20 32 0 32"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M20,88 L20,32 L40,20 L40,0 L60,0 L60,88 L20,88 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "36",
                    width: "4",
                    height: "48"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "36",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "44",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "52",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "60",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-21"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-21"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-22"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-22"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "36",
                    width: "4",
                    height: "48"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "36",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "44",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "52",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "60",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-23"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-23"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-24"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-24"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "20",
                    y: "0",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-25"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-25"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-26"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-26"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-27"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-27"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-28"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-28"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-29"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-29"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-30"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-30"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "4",
                    width: "4",
                    height: "16"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-31"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-31"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-32"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-32"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-33"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-33"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-34"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-34"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-35"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-35"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-36"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-36"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-37"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-37"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-38"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-38"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-39"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-39"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-40"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                      xlinkHref: "#path-40"
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(322.000000, 0.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "4",
                    width: "40",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    transform: "translate(20.000000, 2.000000) scale(1, -1) translate(-20.000000, -2.000000) ",
                    x: "8",
                    y: "0",
                    width: "24",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,4 L32,0 L48,0 L48,4 L56,4 L56,128 L40,128 L40,4 L32,4 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "12",
                    width: "8",
                    height: "108"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "28",
                    y: "12",
                    width: "8",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "44",
                    y: "12",
                    width: "8",
                    height: "108"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(244.000000, 23.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "48",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "0",
                    width: "20",
                    height: "124"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "38",
                    height: "100"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "4 44 4 32 42 56 42 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "4 53 4 48 42 72 42 77"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "52",
                    y: "16",
                    width: "12",
                    height: "100"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "6",
                    width: "16",
                    height: "6"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(342.500000, 69.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "8",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "16",
                    width: "4",
                    height: "32"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(382.500000, 83.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 1.08052456e-13 28 1.08052456e-13 28 68 0 68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "68"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "16",
                    width: "4",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "8",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "16",
                    width: "4",
                    height: "32"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(269.000000, 77.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "16",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "40",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "48",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "0",
                    width: "16",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "8",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "16",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "24",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "32",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "40",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "48",
                    width: "16",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(444.000000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "16",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "32",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "40",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "0",
                    y: "48",
                    width: "20",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "0",
                    width: "16",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "8",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "16",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "24",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "32",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "40",
                    width: "16",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "20",
                    y: "48",
                    width: "16",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(224.500000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(513.000000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(280.500000, 101.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M32,36 L32,56 L12,56 L12,36 L32,36 Z M44,0 L44,36 L32,36 L32,0 L44,0 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M56,36 L56,8 L68,8 L68,56 L48,56 L48,36 L56,36 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "12",
                    y: "0",
                    width: "20",
                    height: "36"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "28",
                    y: "36",
                    width: "20",
                    height: "20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "8",
                    width: "20",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "16",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "40",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "48",
                    y: "28",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "28",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(348.500000, 129.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "0",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "0",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "20",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "20",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "4",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "4",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(398.500000, 65.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "20",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 0 40 0 20 20 0 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 20 40 0 40 20 40 76 20 76"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "64",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(485.500000, 81.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "20",
                    width: "20",
                    height: "56"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "20 0 40 0 20 20 0 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 20 40 0 40 20 40 76 20 76"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "24",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "32",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "40",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "48",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "56",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "64",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "64",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(56.000000, 121.000000) scale(-1, 1) translate(-56.000000, -121.000000) translate(14.000000, 97.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "36",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "24",
                    width: "12",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "72",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "30 0 32 0 32 24 28 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "16 0 18 0 18 24 14 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "32 0 34 0 36 24 32 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "18 0 20 0 22 24 18 24"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(612.500000, 91.500000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "32",
                    y: "12",
                    width: "12",
                    height: "40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M20,52 L20,32 L44,32 L44,12 L56,12 L56,52 L20,52 Z",
                    fill: "#D0DDF9",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "44 0 44 12 32 12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    cx: "38",
                    cy: "18",
                    r: "2"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    cx: "50",
                    cy: "18",
                    r: "2"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "44 0 56 12 44 12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    points: "0 32 10 24 20 32 20 52 0 52"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "10 24 38 24 48 32 20 32"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M10,40 C11.1045695,40 12,40.8954305 12,42 L12,52 L12,52 L8,52 L8,42 C8,40.8954305 8.8954305,40 10,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M26,36 C27.1045695,36 28,36.8954305 28,38 L28,48 L28,48 L24,48 L24,38 C24,36.8954305 24.8954305,36 26,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M34,36 C35.1045695,36 36,36.8954305 36,38 L36,48 L36,48 L32,48 L32,38 C32,36.8954305 32.8954305,36 34,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,36 C43.1045695,36 44,36.8954305 44,38 L44,48 L44,48 L40,48 L40,38 C40,36.8954305 40.8954305,36 42,36 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "8",
                    y: "32",
                    width: "4",
                    height: "4",
                    rx: "2"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(388.000000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(172.000000, 121.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(29.500000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(576.500000, 127.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "2",
                    width: "28",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "2",
                    width: "12",
                    height: "28"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M0,2 L0,0 L40,0 L40,2 L0,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "22",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "22",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "14",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "6",
                    width: "4",
                    height: "4"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(422.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(150.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(186.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 34 0 28 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,2 L20,8 L28,8 L28,20 L0,20 L0,8 L8,8 L14,2 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "28 8 34 0 40 8 40 20 28 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "32",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A1BBF3",
                    className: "fill-primary40",
                    transform: "translate(20.000000, 5.000000) rotate(-180.000000) translate(-20.000000, -5.000000) ",
                    points: "20 2 26 8 14 8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(461.500000, 119.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M16,14 L16,2 L52,2 L52,14 L44,14 L44,26 L36,26 L36,38 L0,38 L0,26 L8,26 L8,14 L16,14 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "30",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "30",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "24",
                    y: "30",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M44,26 L44,14 L52,14 L52,2 L64,2 L64,38 L36,38 L36,26 L44,26 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "36",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "20",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "28",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "36",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "44",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "6",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "56",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "18",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "40",
                    y: "30",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M16,2 L16,0 L64,0 L64,2 L16,2 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(675.000000, 133.000000) scale(-1, 1) translate(-675.000000, -133.000000) translate(633.000000, 109.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    x: "0",
                    y: "24",
                    width: "36",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "36",
                    y: "24",
                    width: "12",
                    height: "24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "60",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "72",
                    y: "24",
                    width: "12",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,32 C7.1045695,32 8,32.8954305 8,34 L8,36 L8,36 L4,36 L4,34 C4,32.8954305 4.8954305,32 6,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M48,48 L48,36 L60,24 L60,36 L72,24 L72,36 L84,24 L84,48 L48,48 Z",
                    fill: "#D8E5F8",
                    className: "fill-primary10"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M6,40 C7.1045695,40 8,40.8954305 8,42 L8,44 L8,44 L4,44 L4,42 C4,40.8954305 4.8954305,40 6,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,32 C15.1045695,32 16,32.8954305 16,34 L16,36 L16,36 L12,36 L12,34 C12,32.8954305 12.8954305,32 14,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M14,40 C15.1045695,40 16,40.8954305 16,42 L16,44 L16,44 L12,44 L12,42 C12,40.8954305 12.8954305,40 14,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,32 C23.1045695,32 24,32.8954305 24,34 L24,36 L24,36 L20,36 L20,34 C20,32.8954305 20.8954305,32 22,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M22,40 C23.1045695,40 24,40.8954305 24,42 L24,44 L24,44 L20,44 L20,42 C20,40.8954305 20.8954305,40 22,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,32 C31.1045695,32 32,32.8954305 32,34 L32,36 L32,36 L28,36 L28,34 C28,32.8954305 28.8954305,32 30,32 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M30,40 C31.1045695,40 32,40.8954305 32,42 L32,44 L32,44 L28,44 L28,42 C28,40.8954305 28.8954305,40 30,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,40 C43.1045695,40 44,40.8954305 44,42 L44,44 L44,44 L40,44 L40,42 C40,40.8954305 40.8954305,40 42,40 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M54,40 C55.1045695,40 56,40.8954305 56,42 L56,48 L56,48 L52,48 L52,42 C52,40.8954305 52.8954305,40 54,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M66,40 C67.1045695,40 68,40.8954305 68,42 L68,48 L68,48 L64,48 L64,42 C64,40.8954305 64.8954305,40 66,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M78,40 C79.1045695,40 80,40.8954305 80,42 L80,48 L80,48 L76,48 L76,42 C76,40.8954305 76.8954305,40 78,40 Z",
                    fill: "#A0BCF0",
                    className: "fill-primary40"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M42,32 C43.1045695,32 44,32.8954305 44,34 L44,36 L44,36 L40,36 L40,34 C40,32.8954305 40.8954305,32 42,32 Z",
                    fill: "#C3D5F5",
                    className: "fill-primary20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "30 0 32 0 32 24 28 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "16 0 18 0 18 24 14 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "32 0 34 0 36 24 32 24"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#D0DDF9",
                    className: "fill-primary20",
                    points: "18 0 20 0 22 24 18 24"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(604.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(0.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(699.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "20",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 26 0 20 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "20 8 26 0 32 8 32 20 20 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "12",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "4",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(533.000000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "44",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 50 0 44 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "44 8 50 0 56 8 56 20 44 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  transform: "translate(61.500000, 137.000000)",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#D8E5F8",
                    className: "fill-primary10",
                    x: "0",
                    y: "8",
                    width: "44",
                    height: "12"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    points: "6 0 50 0 44 8 0 8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    points: "44 8 50 0 56 8 56 20 44 20"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "24",
                    y: "12",
                    width: "4",
                    height: "8"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "32",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#C3D5F5",
                    className: "fill-primary20",
                    x: "4",
                    y: "12",
                    width: "8",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "48",
                    y: "12",
                    width: "4",
                    height: "4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    fill: "#A0BCF0",
                    className: "fill-primary40",
                    x: "16",
                    y: "12",
                    width: "4",
                    height: "8"
                  })]
                })]
              })]
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      viewBox: "0 0 748 120",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
          id: "path-1",
          points: "31.7880795 12.7152318 41.3245033 5.51435277e-17 50.8609272 12.7152318 50.8609272 31.7880795 -3.61388623e-13 31.7880795 -2.24367986e-13 12.7152318"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Page-2",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          id: "bbl_footer-3",
          transform: "translate(-412.000000, -98.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            id: "new",
            transform: "translate(412.000000, 98.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-1",
              transform: "translate(396.556291, 113.642384)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "plant-2",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,0 L0.198023309,0.00302529111 C3.55185104,0.105636077 6.25197982,2.80576485 6.3545906,6.15959259 L6.35761589,6.35761589 L6.15959259,6.3545906 C2.80576485,6.25197982 0.105636077,3.55185104 0.00302529111,0.198023309 L0,0 Z",
                  id: "Path",
                  fill: "#1657E2",
                  className: "fill-primary"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M12.7152318,0 L12.7122065,0.198023309 C12.6116479,3.48477449 10.0164331,6.14371319 6.75606888,6.34533248 L6.5556392,6.3545906 L6.35761589,6.35761589 L6.36064119,6.15959259 C6.46119976,2.87284141 9.0564146,0.213902708 12.3167788,0.0122834093 L12.5172085,0.00302529111 L12.7152318,0 Z",
                  id: "Path",
                  fill: "#779DED",
                  className: "fill-primary40"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-terraseblokk-/-bygning",
              transform: "translate(81.059603, 59.602649)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "terraseblokk",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,60.397351 L0,41.3245033 L12.7152318,41.3245033 L12.7152318,22.2516556 L25.4304636,22.2516556 L25.4304636,3.17880795 L101.721854,3.17880795 L101.721854,60.397351 L0,60.397351 Z",
                  id: "Combined-Shape",
                  fill: "#FFFFFF"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#091E43",
                  x: "25.4304636",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-54",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "47.6821192",
                  width: "12.7152318",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-55",
                  fill: "#C3D0D8",
                  x: "38.1456954",
                  y: "47.6821192",
                  width: "12.7152318",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M69.9337748,41.3245033 L69.9337748,22.2516556 L82.6490066,22.2516556 L82.6490066,3.17880795 L101.721854,3.17880795 L101.721854,60.397351 L57.218543,60.397351 L57.218543,41.3245033 L69.9337748,41.3245033 Z",
                  id: "Combined-Shape",
                  fill: "#C3D0D8"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-56",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-57",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-83",
                  fill: "#C3D0D8",
                  x: "44.5033113",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-84",
                  fill: "#C3D0D8",
                  x: "57.218543",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-58",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-59",
                  fill: "#C3D0D8",
                  x: "44.5033113",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-79",
                  fill: "#C3D0D8",
                  x: "57.218543",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-82",
                  fill: "#C3D0D8",
                  x: "69.9337748",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-61",
                  fill: "#091E43",
                  x: "89.0066225",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-63",
                  fill: "#091E43",
                  x: "89.0066225",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-66",
                  fill: "#091E43",
                  x: "89.0066225",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-64",
                  fill: "#091E43",
                  x: "76.2913907",
                  y: "28.6092715",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-67",
                  fill: "#091E43",
                  x: "76.2913907",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-68",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#091E43",
                  x: "25.4304636",
                  y: "0",
                  width: "76.2913907",
                  height: "3.17880795"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-rekkehus-/-bygning",
              transform: "translate(189.139073, 88.211921)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "rekkehus",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-14",
                  fill: "#FFFFFF",
                  x: "0",
                  y: "12.7152318",
                  width: "31.7880795",
                  height: "19.0728477"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-24",
                  fill: "#091E43",
                  points: "9.53642384 0 41.3245033 0 31.7880795 12.7152318 0 12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-25",
                  fill: "#C3D0D8",
                  points: "31.7880795 12.7152318 41.3245033 0 50.8609272 12.7152318 50.8609272 31.7880795 31.7880795 31.7880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-26",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r-copy-2",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-13",
                  fill: "#FFFFFF",
                  x: "34.9668874",
                  y: "12.7152318",
                  width: "31.7880795",
                  height: "19.0728477"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-21",
                  fill: "#091E43",
                  points: "44.5033113 0 76.2913907 0 66.7549669 12.7152318 34.9668874 12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-22",
                  fill: "#C3D0D8",
                  points: "66.7549669 12.7152318 76.2913907 0 85.8278146 12.7152318 85.8278146 31.7880795 66.7549669 31.7880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-23",
                  fill: "#C3D0D8",
                  x: "54.0397351",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r-copy",
                  fill: "#C3D0D8",
                  x: "41.3245033",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-12",
                  fill: "#FFFFFF",
                  x: "69.9337748",
                  y: "12.7152318",
                  width: "31.7880795",
                  height: "19.0728477"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-15",
                  fill: "#091E43",
                  points: "79.4701987 0 111.258278 0 101.721854 12.7152318 69.9337748 12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-16",
                  fill: "#C3D0D8",
                  points: "101.721854 12.7152318 111.258278 0 120.794702 12.7152318 120.794702 31.7880795 101.721854 31.7880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "89.0066225",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-18",
                  fill: "#091E43",
                  x: "108.07947",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r",
                  fill: "#C3D0D8",
                  x: "76.2913907",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "12.7152318"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-h\xF8yblokk-/-bygning",
              transform: "translate(303.576159, 21.456954)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "h\xF8yblokk",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#FFFFFF",
                  x: "0",
                  y: "3.17880795",
                  width: "76.2913907",
                  height: "95.3642384"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-5",
                  fill: "#C3D0D8",
                  x: "44.5033113",
                  y: "3.17880795",
                  width: "31.7880795",
                  height: "95.3642384"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy",
                  fill: "#091E43",
                  x: "0",
                  y: "0",
                  width: "76.2913907",
                  height: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-41",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-29",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-42",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-33",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-43",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-31",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-44",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-34",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-49",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-50",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-52",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-51",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-45",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-27",
                  fill: "#091E43",
                  x: "19.0728477",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-28",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-46",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-35",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-38",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-30",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-47",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-36",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-39",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-32",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-48",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-37",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-40",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-h\xF8yblokk-/-bygning",
              transform: "translate(495.894040, 21.456954)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "h\xF8yblokk",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#FFFFFF",
                  x: "0",
                  y: "3.17880795",
                  width: "76.2913907",
                  height: "95.3642384"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-5",
                  fill: "#C3D0D8",
                  x: "44.5033113",
                  y: "3.17880795",
                  width: "31.7880795",
                  height: "95.3642384"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy",
                  fill: "#091E43",
                  x: "0",
                  y: "0",
                  width: "76.2913907",
                  height: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-41",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-29",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-42",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-33",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-43",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-31",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-44",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-34",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-49",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-50",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-52",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-51",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-45",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-27",
                  fill: "#091E43",
                  x: "19.0728477",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-28",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "85.8278146",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-46",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "47.6821192",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-35",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-38",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-30",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "73.1125828",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-47",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-36",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-39",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-32",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "60.397351",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-48",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-37",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-40",
                  fill: "#091E43",
                  x: "63.5761589",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-hus-/-bygning",
              transform: "translate(614.304636, 85.033113)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "hus",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-8",
                  fill: "#FFFFFF",
                  x: "3.97350993",
                  y: "0",
                  width: "6.35761589",
                  height: "11.9205298"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#C3D0D8",
                  x: "7.15231788",
                  y: "0",
                  width: "4.76821192",
                  height: "7.15231788"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-15",
                  fill: "#091E43",
                  points: "9.53642384 3.17880795 54.0397351 3.17880795 44.5033113 15.8940397 0 15.8940397"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,34.9668874 L0,15.8940397 L12.7152318,15.8940397 L22.2516556,6.35761589 L41.3245033,6.35761589 L31.7880795,15.8940397 L44.5033113,15.8940397 L54.0397351,3.17880795 L63.5761589,15.8940397 L63.5761589,34.9668874 L0,34.9668874 Z",
                  id: "Combined-Shape",
                  fill: "#FFFFFF"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-16",
                  fill: "#C3D0D8",
                  points: "44.5033113 15.8940397 54.0397351 3.17880795 63.5761589 15.8940397 63.5761589 34.9668874 44.5033113 34.9668874"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-19",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-18",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-7",
                  fill: "#C3D0D8",
                  transform: "translate(31.788079, 11.125828) rotate(-180.000000) translate(-31.788079, -11.125828) ",
                  points: "31.7880795 6.35761589 41.3245033 15.8940397 22.2516556 15.8940397"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-lavblokk-/-bygning",
              transform: "translate(354.437086, 72.317881)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "lavblokk",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#FFFFFF",
                  x: "0",
                  y: "3.17880795",
                  width: "63.5761589",
                  height: "44.5033113"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-5",
                  fill: "#C3D0D8",
                  x: "44.5033113",
                  y: "3.17880795",
                  width: "19.0728477",
                  height: "44.5033113"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy",
                  fill: "#091E43",
                  x: "0",
                  y: "0",
                  width: "63.5761589",
                  height: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-29",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-33",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-31",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-34",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-27",
                  fill: "#091E43",
                  x: "19.0728477",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-28",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-35",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "34.9668874",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-30",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-36",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-32",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-37",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "9.53642384",
                  width: "6.35761589",
                  height: "6.35761589"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sm\xE5hus-/-bygning",
              transform: "translate(670.728477, 88.211921)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "sm\xE5hus",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-12",
                  fill: "#FFFFFF",
                  x: "0",
                  y: "12.7152318",
                  width: "31.7880795",
                  height: "19.0728477"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                  id: "mask-2",
                  fill: "white",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                    xlinkHref: "#path-1"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                  id: "Rectangle-Copy-13",
                  fill: "#FFFFFF",
                  xlinkHref: "#path-1"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-15",
                  fill: "#091E43",
                  points: "9.53642384 0 41.3245033 0 31.7880795 12.7152318 0 12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-16",
                  fill: "#C3D0D8",
                  points: "31.7880795 12.7152318 41.3245033 0 50.8609272 12.7152318 50.8609272 31.7880795 31.7880795 31.7880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-18",
                  fill: "#091E43",
                  x: "38.1456954",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "19.0728477",
                  width: "6.35761589",
                  height: "12.7152318"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-hus-/-bygning",
              transform: "translate(406.092715, 85.033113)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "hus",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-8",
                  fill: "#FFFFFF",
                  x: "3.97350993",
                  y: "0",
                  width: "6.35761589",
                  height: "11.9205298"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#C3D0D8",
                  x: "7.15231788",
                  y: "0",
                  width: "4.76821192",
                  height: "7.15231788"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-15",
                  fill: "#091E43",
                  points: "9.53642384 3.17880795 54.0397351 3.17880795 44.5033113 15.8940397 0 15.8940397"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,34.9668874 L0,15.8940397 L12.7152318,15.8940397 L22.2516556,6.35761589 L41.3245033,6.35761589 L31.7880795,15.8940397 L44.5033113,15.8940397 L54.0397351,3.17880795 L63.5761589,15.8940397 L63.5761589,34.9668874 L0,34.9668874 Z",
                  id: "Combined-Shape",
                  fill: "#FFFFFF"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-16",
                  fill: "#C3D0D8",
                  points: "44.5033113 15.8940397 54.0397351 3.17880795 63.5761589 15.8940397 63.5761589 34.9668874 44.5033113 34.9668874"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-19",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-18",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-7",
                  fill: "#C3D0D8",
                  transform: "translate(31.788079, 11.125828) rotate(-180.000000) translate(-31.788079, -11.125828) ",
                  points: "31.7880795 6.35761589 41.3245033 15.8940397 22.2516556 15.8940397"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-hus-/-bygning",
              transform: "translate(546.754967, 85.033113)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "hus",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-8",
                  fill: "#FFFFFF",
                  x: "3.97350993",
                  y: "0",
                  width: "6.35761589",
                  height: "11.9205298"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#C3D0D8",
                  x: "7.15231788",
                  y: "0",
                  width: "4.76821192",
                  height: "7.15231788"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-15",
                  fill: "#091E43",
                  points: "9.53642384 3.17880795 54.0397351 3.17880795 44.5033113 15.8940397 0 15.8940397"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,34.9668874 L0,15.8940397 L12.7152318,15.8940397 L22.2516556,6.35761589 L41.3245033,6.35761589 L31.7880795,15.8940397 L44.5033113,15.8940397 L54.0397351,3.17880795 L63.5761589,15.8940397 L63.5761589,34.9668874 L0,34.9668874 Z",
                  id: "Combined-Shape",
                  fill: "#FFFFFF"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-16",
                  fill: "#C3D0D8",
                  points: "44.5033113 15.8940397 54.0397351 3.17880795 63.5761589 15.8940397 63.5761589 34.9668874 44.5033113 34.9668874"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-17",
                  fill: "#C3D0D8",
                  x: "31.7880795",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-19",
                  fill: "#C3D0D8",
                  x: "6.35761589",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle-Copy-18",
                  fill: "#091E43",
                  x: "50.8609272",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "d\xF8r",
                  fill: "#C3D0D8",
                  x: "19.0728477",
                  y: "22.2516556",
                  width: "6.35761589",
                  height: "12.7152318"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                  id: "Rectangle-Copy-7",
                  fill: "#C3D0D8",
                  transform: "translate(31.788079, 11.125828) rotate(-180.000000) translate(-31.788079, -11.125828) ",
                  points: "31.7880795 6.35761589 41.3245033 15.8940397 22.2516556 15.8940397"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-2",
              transform: "translate(131.920530, 113.642384)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.198023309,0.00302529111 C3.55185104,0.105636077 6.25197982,2.80576485 6.3545906,6.15959259 L6.35761589,6.35761589 L6.15959259,6.3545906 C2.80576485,6.25197982 0.105636077,3.55185104 0.00302529111,0.198023309 L0,0 Z M12.7152318,0 L12.7122065,0.198023309 C12.6116479,3.48477449 10.0164331,6.14371319 6.75606888,6.34533248 L6.5556392,6.3545906 L6.35761589,6.35761589 L6.36064119,6.15959259 C6.46119976,2.87284141 9.0564146,0.213902708 12.3167788,0.0122834093 L12.5172085,0.00302529111 L12.7152318,0 Z",
                id: "plant-1"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-1",
              transform: "translate(395.761589, 113.642384)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "plant-2",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,0 L0.198023309,0.00302529111 C3.55185104,0.105636077 6.25197982,2.80576485 6.3545906,6.15959259 L6.35761589,6.35761589 L6.15959259,6.3545906 C2.80576485,6.25197982 0.105636077,3.55185104 0.00302529111,0.198023309 L0,0 Z",
                  id: "Path",
                  fill: "#1657E2",
                  className: "fill-primary"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M12.7152318,0 L12.7122065,0.198023309 C12.6116479,3.48477449 10.0164331,6.14371319 6.75606888,6.34533248 L6.5556392,6.3545906 L6.35761589,6.35761589 L6.36064119,6.15959259 C6.46119976,2.87284141 9.0564146,0.213902708 12.3167788,0.0122834093 L12.5172085,0.00302529111 L12.7152318,0 Z",
                  id: "Path",
                  fill: "#779DED",
                  className: "fill-primary40"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-1",
              transform: "translate(654.834437, 113.642384)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "plant-2",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M0,0 L0.198023309,0.00302529111 C3.55185104,0.105636077 6.25197982,2.80576485 6.3545906,6.15959259 L6.35761589,6.35761589 L6.15959259,6.3545906 C2.80576485,6.25197982 0.105636077,3.55185104 0.00302529111,0.198023309 L0,0 Z",
                  id: "Path",
                  fill: "#1657E2",
                  className: "fill-primary"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M12.7152318,0 L12.7122065,0.198023309 C12.6116479,3.48477449 10.0164331,6.14371319 6.75606888,6.34533248 L6.5556392,6.3545906 L6.35761589,6.35761589 L6.36064119,6.15959259 C6.46119976,2.87284141 9.0564146,0.213902708 12.3167788,0.0122834093 L12.5172085,0.00302529111 L12.7152318,0 Z",
                  id: "Path",
                  fill: "#779DED",
                  className: "fill-primary40"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-3",
              transform: "translate(166.092715, 110.463576)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,9.53642384 C0,6.02520954 2.84640159,3.17880795 6.35761589,3.17880795 C8.05030579,3.17880795 9.58849178,3.84031778 10.7277559,4.91891948 C12.353016,1.98571535 15.4810375,0 19.0728477,0 C24.2586411,0 28.4776631,4.13924056 28.6062518,9.29405977 L28.6092715,9.53642384 L0,9.53642384 Z",
                id: "bush-2"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-tre-1",
              transform: "translate(586.490066, 81.854305)",
              fill: "#0842C0",
              className: "fill-dark-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M10.1591185,0 C18.7436196,16.9536424 21.9224275,29.6688742 19.6955424,38.1456954 C14.3792862,38.1456954 9.06571703,38.1456954 0.622694697,38.1456954 C-1.46920836,29.6688742 1.70959959,16.9536424 10.1591185,0 Z",
                id: "tree-"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-tre-1",
              transform: "translate(712.847682, 81.854305)",
              fill: "#0842C0",
              className: "fill-dark-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M10.1591185,0 C18.7436196,16.9536424 21.9224275,29.6688742 19.6955424,38.1456954 C14.3792862,38.1456954 9.06571703,38.1456954 0.622694697,38.1456954 C-1.46920836,29.6688742 1.70959959,16.9536424 10.1591185,0 Z",
                id: "tree-"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-tre-2",
              transform: "translate(163.708609, 94.569536)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "tree-2",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#779DED",
                  className: "fill-primary40",
                  x: "0",
                  y: "0",
                  width: "12.7152318",
                  height: "19.0728477",
                  rx: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#091E43",
                  x: "5.56291391",
                  y: "9.53642384",
                  width: "1.58940397",
                  height: "15.8940397",
                  rx: "0.794701987"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-tre-2",
              transform: "translate(473.642384, 94.569536)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "tree-2",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#779DED",
                  className: "fill-primary40",
                  x: "0",
                  y: "0",
                  width: "12.7152318",
                  height: "19.0728477",
                  rx: "6.35761589"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  id: "Rectangle",
                  fill: "#091E43",
                  x: "5.56291391",
                  y: "9.53642384",
                  width: "1.58940397",
                  height: "15.8940397",
                  rx: "0.794701987"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-3",
              transform: "translate(454.569536, 110.463576)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,9.53642384 C0,6.02520954 2.84640159,3.17880795 6.35761589,3.17880795 C8.05030579,3.17880795 9.58849178,3.84031778 10.7277559,4.91891948 C12.353016,1.98571535 15.4810375,0 19.0728477,0 C24.2586411,0 28.4776631,4.13924056 28.6062518,9.29405977 L28.6092715,9.53642384 L0,9.53642384 Z",
                id: "bush-2"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-3",
              transform: "translate(584.105960, 110.463576)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,9.53642384 C0,6.02520954 2.84640159,3.17880795 6.35761589,3.17880795 C8.05030579,3.17880795 9.58849178,3.84031778 10.7277559,4.91891948 C12.353016,1.98571535 15.4810375,0 19.0728477,0 C24.2586411,0 28.4776631,4.13924056 28.6062518,9.29405977 L28.6092715,9.53642384 L0,9.53642384 Z",
                id: "bush-2"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-3",
              transform: "translate(733.509934, 115.231788) scale(-1, 1) translate(-733.509934, -115.231788) translate(719.205298, 110.463576)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,9.53642384 C0,6.02520954 2.84640159,3.17880795 6.35761589,3.17880795 C8.05030579,3.17880795 9.58849178,3.84031778 10.7277559,4.91891948 C12.353016,1.98571535 15.4810375,0 19.0728477,0 C24.2586411,0 28.4776631,4.13924056 28.6062518,9.29405977 L28.6092715,9.53642384 L0,9.53642384 Z",
                id: "bush-2"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-busk-2",
              transform: "translate(252.715232, 113.642384)",
              fill: "#1657E2",
              className: "fill-primary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.198023309,0.00302529111 C3.55185104,0.105636077 6.25197982,2.80576485 6.3545906,6.15959259 L6.35761589,6.35761589 L6.15959259,6.3545906 C2.80576485,6.25197982 0.105636077,3.55185104 0.00302529111,0.198023309 L0,0 Z M12.7152318,0 L12.7122065,0.198023309 C12.6116479,3.48477449 10.0164331,6.14371319 6.75606888,6.34533248 L6.5556392,6.3545906 L6.35761589,6.35761589 L6.36064119,6.15959259 C6.46119976,2.87284141 9.0564146,0.213902708 12.3167788,0.0122834093 L12.5172085,0.00302529111 L12.7152318,0 Z",
                id: "plant-1"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-bil",
              transform: "translate(35.761589, 104.105960)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "bil",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval",
                  fill: "#0B358D",
                  className: "fill-primary",
                  cx: "17.4834437",
                  cy: "12.7152318",
                  r: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval-Copy-2",
                  fill: "#0B358D",
                  className: "fill-primary",
                  cx: "36.5562914",
                  cy: "12.7152318",
                  r: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M17.4834437,0 L30.9933775,0 C34.5045918,2.01953566e-15 37.3509934,2.84640159 37.3509934,6.35761589 L37.3509934,6.35761589 L37.3509934,6.35761589 L17.4834437,6.35761589 L17.4834437,0 Z",
                  id: "Rectangle-Copy-72",
                  fill: "#1657E2",
                  className: "fill-primary"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M12.7152318,0 L19.8675497,0 C23.3024332,-6.30977873e-16 26.1010948,2.72399018 26.2211524,6.12958862 L26.2251656,6.35761589 L41.3245033,6.35761589 L41.3245033,12.7152318 L6.35761589,12.7152318 C2.84640159,12.7152318 4.29999736e-16,9.8688302 0,6.35761589 L6.35761589,6.35761589 C6.35761589,2.84640159 9.20401748,1.53317802e-15 12.7152318,0 Z",
                  id: "Combined-Shape",
                  fill: "#779DED",
                  className: "fill-primary40"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M31.7880795,6.35761589 L50.8609272,6.35761589 C50.8609272,9.8688302 48.0145256,12.7152318 44.5033113,12.7152318 L38.1456954,12.7152318 C34.6344811,12.7152318 31.7880795,9.8688302 31.7880795,6.35761589 L31.7880795,6.35761589 L31.7880795,6.35761589 Z",
                  id: "Rectangle-Copy-70",
                  fill: "#1657E2",
                  className: "fill-primary"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval",
                  fill: "#F0F0F0",
                  cx: "37.3509934",
                  cy: "9.53642384",
                  r: "1.58940397"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval-Copy-3",
                  fill: "#F0F0F0",
                  cx: "46.0927152",
                  cy: "9.53642384",
                  r: "1.58940397"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval",
                  fill: "#000000",
                  cx: "9.53642384",
                  cy: "12.7152318",
                  r: "3.17880795"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                  id: "Oval-Copy-2",
                  fill: "#000000",
                  cx: "28.6092715",
                  cy: "12.7152318",
                  r: "3.17880795"
                })]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(214.569536, 59.602649)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(230.463576, 0.000000)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(121.589404, 20.662252) scale(-1, 1) translate(-121.589404, -20.662252) translate(107.284768, 15.894040)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(0.000000, 43.708609)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(418.013245, 43.708609)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(692.980132, 4.768212)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sky",
              transform: "translate(646.887417, 60.397351) scale(-1, 1) translate(-646.887417, -60.397351) translate(632.582781, 55.629139)",
              fill: "#FFFFFF",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M28.6092715,9.53642384 C28.6092715,6.02520954 25.7628699,3.17880795 22.2516556,3.17880795 C20.5589657,3.17880795 19.0207797,3.84031778 17.8815156,4.91891948 C16.2562555,1.98571535 13.128234,0 9.53642384,0 C4.35063041,0 0.131608409,4.13924056 0.00301975451,9.29405977 L0,9.53642384 L28.6092715,9.53642384 Z",
                id: "cloud"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "illustrasjon-/-sol",
              transform: "translate(460.927152, 9.536424)",
              fill: "#10105A",
              className: "fill-secondary",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                id: "Sol",
                cx: "9.53642384",
                cy: "9.53642384",
                r: "9.53642384"
              })
            })]
          })
        })
      })]
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationHousesBackgroundWithComposition')(IllustrationHousesBackgroundWithComposition);